import React, { useState } from 'react';
import FormErrorMessage from '../Errormessage';
import classes from './style.module.scss';
import { Icons, Images } from '../../assets';
import { Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import { getFormat } from '../../helpers';

const FileUpload = (props) => {
    const {
        className = '',
        error,
        messages,
        label,
        name,
        onChange,
        control,
        acceptFiles,
        fileNames = [],
        isFileUploading = false,
        placeholder = '',
        fieldArrayName,
        multiple = false,
        alignment = '',
        required = true,
        ...rest
    } = props;

    const [fileSizeError, setFileSizeError] = useState('')

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) {
            rest.setFileName([]);
            rest.setUploadedFiles([]);
            return;
        }

        let validFiles = [];
        let errors = {};

        files.forEach(file => {
            if (rest?.maxSize && file?.size > rest?.maxSize) {
                setFileSizeError(`Fize size cannot be greater than ${rest?.maxLable || '20MB'}`)
            } else {
                if (acceptFiles?.length > 0) {
                    if (acceptFiles.split(',').map(type => type.trim()).includes(file.type)) {
                        validFiles.push(file);
                    } else {
                        errors.fileUpload = 'One or more files are not of allowed type.';
                    }
                } else {
                    validFiles.push(file);
                }
                setFileSizeError('')
            }
        });

        if (validFiles.length > 0) {
            rest.setValue(name, multiple ? validFiles.map(file => file.name) : [validFiles[0].name])
            rest.setUploadedFiles(validFiles);
            rest.setFileName(multiple ? validFiles.map(file => file.name) : [validFiles[0].name]);
        }
        if (Object.keys(errors).length > 0) {
            rest.setError(name, { type: 'manual', message: errors.fileUpload });
        } else {
            rest.clearErrors(name);
        }
    };

    const handleRemoveFile = (fileName) => {
        if (rest?.setFileName) {
            const updatedFiles = fileNames.filter(name => name !== fileName);
            rest.setFileName(updatedFiles);
        }
        if (rest.setUploadedFiles) {
            rest?.setUploadedFiles(rest.uploadedFiles?.filter(file => file.name !== fileName))
        }
    };

    const getCallBack = () => {
        if (fileNames?.length > 0 && multiple) {
            return (
                <div className='p-4'>
                    {fileNames.map(fileName => (
                        <div key={fileName} className="py-2 flex items-center justify-between">
                            <div style={{ fontSize: '14px', width: '90%' }}>{fileName}</div>
                            <div>
                                <img src={Icons.delete} alt='Delete' style={{ width: '20px' }} onClick={() => handleRemoveFile(fileName)} />
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
        return null;
    };

    const getPreviewScreen = () => {
        if (fileNames?.length > 0 && !multiple) {
            return (
                fileNames?.map(fileName => (
                    <div key={fileName} className={`${classes.placeholder} ${classes.previewScreen} ${alignment === 'center' ? classes.centerAlign : ''} flex w-[100%]`}>
                        <div className={`w-[${alignment === 'center' ? 'auto' : '80%'}] flex items-center`}>
                            <img className='h-[30px]' src={getFormat(fileName)} alt={label} />
                            <div className='ml-2' style={{ maxWidth: '350px', textOverflow: 'ellipsis', overflow: 'hidden' }} title={fileName}>{fileName}</div>
                        </div>
                        <div className={classes.uploadIcon} onClick={() => handleRemoveFile(fileName)}>
                            <img src={Icons.uploadSecondary} alt={'Upload Icon'} />
                        </div>
                    </div>
                ))
            );
        }

        return (
            <div className={`${classes.placeholder} ${classes.previewPlaceholder} ${alignment === 'center' ? classes.centerAlign : ''}`}>
                <div className={classes.uploadTitle}>
                    {isFileUploading ? 'Uploading...' : placeholder}
                </div>
                <div className={classes.uploadIcon}>
                    <img src={Icons.uploadSecondary} alt={'Upload Icon'} />
                </div>
            </div>
        );
    };

    return (
        <FormControl className='w-[100%]'>
            <Controller
                name={name}
                control={control}
                rules={{ required: required ? "Selection is required" : false }}
                render={({ field: { onChange: fieldOnChange, onBlur, value, ref } }) => (
                    <div className={classes.fileUpload}>
                        <div className={`mb-2 ${classes.upload} ${className}`}>
                            {getPreviewScreen()}
                            <input
                                type="file"
                                title=' '
                                onChange={(event) => {
                                    handleFileChange(event);
                                    fieldOnChange(event);
                                }}
                                accept={acceptFiles || ''}
                                disabled={isFileUploading}
                                multiple={multiple}
                            />
                        </div>
                        {getCallBack()}
                        {fileSizeError && fileSizeError !== '' ?
                            <span className="text-danger fs-13 text-red-400">
                                {fileSizeError}
                            </span>
                            :
                            <FormErrorMessage error={error} messages={messages} />
                        }
                    </div>
                )}
            />
        </FormControl>
    );
};

export default FileUpload;
